import { newsletterTokenList } from 'config/newsletter-consent'
import { cleanCurrentUrlQuery } from 'utils/clean-url'

export const initNewsletterConfirmPage = (): void => {
  const params = new URLSearchParams(window.location.search)
  const successCode = params.get('newsletter_consent_success') || ''
  const failedCode = params.get('newsletter_consent_fail') || ''

  const newsletterTokenListDefault = newsletterTokenList.default
  const newsletterTokenListCurrencyComments = newsletterTokenList.currencyComments

  const $confirmText: Record<string, HTMLSpanElement | null> = {
    defaultAndCurrencyComments: document.querySelector<HTMLSpanElement>('[data-text-default]'),
    [newsletterTokenListDefault]: document.querySelector<HTMLSpanElement>('[data-text-5]'),
    [newsletterTokenListCurrencyComments]: document.querySelector<HTMLSpanElement>('[data-text-e]'),
  }

  const getTargetCode = (success: string, fail: string): string | null => {
    const isPair =
      (success === newsletterTokenListDefault && fail === newsletterTokenListCurrencyComments) ||
      (success === newsletterTokenListCurrencyComments && fail === newsletterTokenListDefault)
    return isPair ? success : null
  }

  const showTarget = (code: string): void => {
    const targetElement = $confirmText[code]
    if (!targetElement) return
    $confirmText.defaultAndCurrencyComments?.setAttribute('hidden', '')
    targetElement.removeAttribute('hidden')
  }

  const target = getTargetCode(successCode, failedCode)
  if (target) {
    showTarget(target)
  }

  cleanCurrentUrlQuery()
}
